import React from 'react';

import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = ( props ) => (
    <ul className={classes.NavigationItems}>
        <NavigationItem link="/home" exact clicked={props.clicked}>Home</NavigationItem>
        {props.scheduleCalendarId ?
            <NavigationItem link={"/schedule/" + props.scheduleCalendarId} exact clicked={props.clicked}>
                Book My Friend
            </NavigationItem>:null
        }
        {props.isAuthenticated ? <NavigationItem link="/profile" clicked={props.clicked}>My Page</NavigationItem> : null}
        {/* <NavigationItem link="/blog" exact clicked={props.clicked}>Blogs</NavigationItem> */}
        <NavigationItem link="/about" exact clicked={props.clicked}>About</NavigationItem>
        <NavigationItem link="/view-my-calendar/ivxpnlpZ3T3RoyePKknw" exact clicked={props.clicked}>Demo</NavigationItem>
        {/* <NavigationItem link="/faq" exact clicked={props.clicked}>FAQs</NavigationItem> */}
        {!props.isAuthenticated
            ? <NavigationItem link="/auth" clicked={props.clicked}>My Page</NavigationItem>
            : <NavigationItem link="/logout" clicked={props.clicked}>Logout</NavigationItem>}
    </ul>
);

export default navigationItems;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js